import Close from 'components/icons/close/Close.vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import { ref, watch } from 'vue'
import Draggable from 'vuedraggable'
import { DraggableObject } from 'src/utils/objects/draggable'


export default {
  props: {
    images: {
      type: Array,
      default: []
    },
    priority: {
      type: Number,
      default: 1
    },
    updateImagesSortOrder: {
      type: Function,
      required: true
    }
  },
  components: {
    Close,
    Draggable
  },
  data() {
    return {
      fouDraggable: DraggableObject(this)
    }
  },
  setup(props) {
    const store = useStore()
    const route = useRoute()
    const drag = ref(false)
    const imagesWithNumber = ref([]);

    /**
     * Delete bundle image
     * @param {String} id
     */
    const loading = ref(false)

    const deleteImage = (id, md5) => {
      loading.value = true
      store
        .dispatch('bundle/deleteBundleImage', {
          payload: { bundleId: route.params.id, imageId: id, md5: md5 },
          priority: props.priority
        }).then((response) => {
          const bundleMainImageCount = store.getters['bundle/getBundleInfo']?.assets?.main?.length;
          const bundlInspirationImageCount = store.getters['bundle/getBundleInfo']?.assets?.inspirational?.length;
          if(response?.data?.success) {
            if(props.priority === 1 && !bundleMainImageCount) {
              store.commit('bundle/setBundleMainImageScanStatus', "unset");
            }
            else if( props.priority === 2 && !bundlInspirationImageCount) {
              store.commit('bundle/setBundleInspirationImageScanStatus', "unset");
            }
          }
        })
        .finally(() => {
          loading.value = false
        })
    }

    const emitTheNewOrder = () => {
      if(props.priority === 1) {
        store.commit('bundle/updateNewOrderedBundleImages', imagesWithNumber.value)
      }
      if(props.priority === 2) {
        store.commit('bundle/updateNewOrderedInspirationalImages', imagesWithNumber.value)
      }
      props.updateImagesSortOrder()
    }
     /** Handle drag start event */
    const onDragStart = () =>{
      drag.value = true;
    }
    /**  Handle drag end event */
    const onDragEnd = () =>{
      drag.value = false;
      emitTheNewOrder()
    }
    /** check for the images 
     * based on the updated
     *  order after 
     * dragging  
     */
   
    watch(
      () => props.images,
      (newValue, oldValue) => {
        imagesWithNumber.value = [...newValue]
      },
      { immediate: true }
    )
    return {
      props,
      store,
      route,
      drag,
      deleteImage,
      loading,
      onDragStart,
      onDragEnd,
      emitTheNewOrder,
      imagesWithNumber
    }
  }
}
